import { ContentPage, ContentSection, ContactEmail } from '../components/ContentPage.js';
import type { FooterView } from '../components/SiteFooter.js';
import { useT } from '../i18n/index.js';

/**
 * Who we are and what this site is — the page a visitor (and an ad network)
 * reads to decide whether there is a real person behind the domain.
 *
 * Deliberately specific rather than reassuring: what the app does, who runs
 * it, where the film data comes from and who pays for the servers. The four
 * questions somebody actually has, answered in the order they ask them.
 */
export function AboutScreen({
  onBack,
  onNavigate,
}: {
  onBack: () => void;
  onNavigate: (view: FooterView) => void;
}) {
  const t = useT();

  return (
    <ContentPage
      view="about"
      title={t('about.title')}
      lead={t('about.lead')}
      onBack={onBack}
      onNavigate={onNavigate}
    >
      <ContentSection title={t('about.whatTitle')}>
        <p>{t('about.whatBody1')}</p>
        <p>{t('about.whatBody2')}</p>
      </ContentSection>

      <ContentSection title={t('about.whoTitle')}>
        <p>{t('about.whoBody1')}</p>
        <p>{t('about.whoBody2')}</p>
      </ContentSection>

      <ContentSection title={t('about.dataTitle')}>
        <p>{t('about.dataBody1')}</p>
        <p>{t('about.dataBody2')}</p>
      </ContentSection>

      <ContentSection title={t('about.moneyTitle')}>
        <p>{t('about.moneyBody1')}</p>
        <p>{t('about.moneyBody2')}</p>
      </ContentSection>

      {/* Required by TMDB's API terms: the notice, worded exactly as TMDB
          asks, plus credit to JustWatch for the streaming data. */}
      <ContentSection title={t('about.creditsTitle')}>
        <p>
          <strong>{t('about.creditsTmdb')}</strong>
        </p>
        <p>{t('about.creditsTmdbBody')}</p>
        <p>{t('about.creditsJustWatch')}</p>
        <ul className="content__list">
          <li>
            <a href="https://www.themoviedb.org/" target="_blank" rel="noreferrer noopener">
              {t('about.creditsTmdbLink')}
            </a>
          </li>
          <li>
            <a href="https://www.justwatch.com/" target="_blank" rel="noreferrer noopener">
              {t('about.creditsJustWatchLink')}
            </a>
          </li>
        </ul>
      </ContentSection>

      <ContentSection title={t('about.contactTitle')}>
        <p>
          {t('about.contactBody')} <ContactEmail />
        </p>
      </ContentSection>
    </ContentPage>
  );
}
